var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c("a-modal", {
    attrs: {
      title: _vm.$t("批量下载批改记录"),
      visible: _vm.batchDownVisible,
      width: 500,
      maskClosable: false,
      closable: false
    },
    on: {
      cancel: function ($event) {
        return _vm.$emit("update:batchDownVisible", false);
      }
    }
  }, [_c("div", {
    staticClass: "footer",
    attrs: {
      slot: "footer"
    },
    slot: "footer"
  }, [_c("a-button", {
    staticClass: "marginR10 btn-width",
    attrs: {
      slot: "footer",
      loading: _vm.isLoading
    },
    on: {
      click: function ($event) {
        return _vm.$emit("update:batchDownVisible", false);
      }
    },
    slot: "footer"
  }, [_vm._v(_vm._s(_vm.$t("取消")))]), _c("a-button", {
    staticClass: "marginR15 btn-width",
    attrs: {
      slot: "footer",
      type: "primary",
      loading: _vm.isLoading,
      ghost: ""
    },
    on: {
      click: _vm.searchDown
    },
    slot: "footer"
  }, [_vm._v(_vm._s(_vm.$t("确定")))])], 1), _c("a-spin", {
    attrs: {
      tip: _vm.$t("文件下载中，请勿关闭页面..."),
      spinning: _vm.isLoading
    }
  }, [_c("span", {
    staticStyle: {
      "font-size": "16px"
    }
  }, [_vm._v(_vm._s(_vm.$t("批改生效时间") + ":") + "  ")]), _vm.batchDownVisible ? _c("a-range-picker", {
    staticClass: "marginR15",
    staticStyle: {
      width: "100%",
      "margin-bottom": "50px",
      "margin-top": "5px"
    },
    attrs: {
      format: "YYYY-MM-DD",
      placeholder: [_vm.$t("选择日期"), _vm.$t("选择日期")]
    },
    model: {
      value: _vm.dateRange,
      callback: function ($$v) {
        _vm.dateRange = $$v;
      },
      expression: "dateRange"
    }
  }) : _vm._e()], 1)], 1);
};
var staticRenderFns = [];
render._withStripped = true;
export { render, staticRenderFns };